export default __webpack_public_path__ + "static/media/IBM_Data_Analyst.ba251c8e.pdf";